var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pk10No"},_vm._l((_vm.drawList),function(item,index){return _c('li',{key:index,class:'pk10No' + item},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }